<template>
  <div v-if="canUpdatePassword">
    <div :class="componentClassName">
      <a-page-heading>アカウント情報確認・変更</a-page-heading>

      <m-section>
        <m-action-card title="パスワード変更" icon="lock" :header-border="true" :narrow-body="true">
          <form ref="form" class="t-profile-edit-password__form" @submit.prevent="handleFormSubmit">
            <div class="t-profile-edit-password__fields">
              <m-form-input label="現在のパスワード">
                <a-text-field
                  id="currentPasswordTextField"
                  v-model="userData.current_password"
                  type="password"
                  placeholder="***********"
                />
              </m-form-input>
              <m-form-input label="新しいパスワード">
                <a-text-field
                  id="newPasswordTextField"
                  v-model="userData.password"
                  type="password"
                  placeholder="***********"
                />
              </m-form-input>
              <m-form-input label="新しいパスワード（確認）">
                <a-text-field
                  id="newPasswordConfirmTextField"
                  v-model="userData.password_confirm"
                  type="password"
                  placeholder="***********"
                />
              </m-form-input>
            </div>
            <div class="m-action-card__password-condition">
              <a-text :text="passwordCondition" size="small" />
            </div>
            <m-form-action-buttons class="t-profile-edit-password__buttons">
              <a-button v-if="userInfo" id="passwordSaveButton" variant="block" color="primary" @click="handleSaveClick"
                >保存</a-button
              >
              <a-button id="passwordSaveCancelButton" variant="outlined" color="primary" @click="handleCancelClick"
                >キャンセル</a-button
              >
            </m-form-action-buttons>
          </form>
        </m-action-card>
      </m-section>
    </div>
    <teleport to="body">
      <o-modal
        id="profileEditPassword_resultModal"
        v-model:visible="resultModalVisible"
        class="o-modal-remove-phone-number-confirmation"
        footer-variant="confirmation"
        width="442px"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <template #title>{{ resultModalTitle }}</template>
        <a-text>
          <!-- eslint-disable -->
          <span v-html="resultModalContent" />
          <!-- eslint-enable -->
        </a-text>
        <template #footer>
          <a-button
            id="passwordModalCloseButton"
            variant="block"
            color="primary"
            label="OK"
            size="small"
            @click="handleCloseModal"
          />
        </template>
      </o-modal>

      <o-modal
        id="profileEditPassword_authResultModal"
        v-model:visible="mailAuthResultModalVisible"
        class="o-modal-mail-auth-link-create-info"
        footer-variant="confirmation"
        width="442px"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <template #title>{{ mailAuthResultModalTitle }}</template>
        <a-text>
          <!-- eslint-disable -->
          <span v-html="mailAuthresultModalContent" />
          <!-- eslint-enable -->
        </a-text>
        <template #footer>
          <a-button
            id="passwordMailAuthModalCloseButton"
            variant="block"
            color="primary"
            label="OK"
            size="small"
            @click="handleCloseMailAuthModal"
          />
        </template>
      </o-modal>
    </teleport>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import APageHeading from '@/components/atoms/page-heading';
import MSection from '@/components/molecules/section';
import MActionCard from '@/components/molecules/action-card';
import AButton from '@/components/atoms/button';
import MFormActionButtons from '@/components/molecules/form-action-buttons';
import MFormInput from '@/components/molecules/form-input';
import ATextField from '@/components/atoms/text-field';
import { cloneDeep } from 'lodash';

import { customRequest } from '@/common/customRequest.js';
import { mapActions } from 'vuex';
import { messageContent } from '@/common/messageContent.js';
import { customValidate } from '@/common/customValidate.js';

export default {
  name: 't-profile-edit-password',
  components: {
    APageHeading,
    MSection,
    MActionCard,
    AButton,
    MFormActionButtons,
    MFormInput,
    ATextField,
  },
  mixins: [customRequest, customValidate],
  props: {
    class: {
      type: String,
      default: '',
    },
    userID: {
      type: String,
      required: true,
    },
    companyID: {
      type: String,
      required: true,
    },
    //handleCancelClick: {
    //  type: Function,
    //  default: () => {},
    //},
    //handleSaveClick: {
    //  type: Function,
    //  default: data => {},
    //},
  },
  data() {
    return {
      userData: {
        userID: '',
        companyID: '',
        current_password: '',
        password: '',
        password_confirm: '',
      },
      userInfo: {},
      resultModalTitle: '',
      resultModalContent: '',
      resultModalVisible: false,
      csrfToken: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
      mailAuthResultModalVisible: false,
      mailAuthResultModalTitle: '',
      mailAuthresultModalContent: '',
      passwordCondition: messageContent.passwordCondition,
      canUpdatePassword: false,
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-profile-edit-password');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  async created() {
    await this.postRequest('/idmgmt/getuserdata', { companyID: this.companyID, userID: this.userID })
      .then(e => {
        if (e.status === 'success') {
          this.canUpdatePassword = !e.data.dAccountFlag;
        }
      })
      .catch(() => {
        this.showErrorModal(messageContent.requireTry('検索'));
      });
    // パスワードは更新不可の場合、ProfileList画面に戻ります
    if (!this.canUpdatePassword) {
      this.$router.push({ name: 'ProfileList' });
    }
  },
  methods: {
    ...mapActions(['updateLoginInfo']),
    handleFormSubmit(event) {
      event.preventDefault();
      this.handleSaveClick(cloneDeep(this.userData));
    },
    handleCancelClick() {
      this.$router.push('/profilelist');
    },
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    showInfoModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
    },
    handleSaveClick: function () {
      if (!this.userData.current_password || !this.userData.password || !this.userData.password_confirm) {
        //check required
        this.showErrorModal(messageContent.passwordInputError);
      } else if (
        this.hasSpecialCharacterInString(this.userData.current_password) ||
        this.hasSpecialCharacterInString(this.userData.password) ||
        this.hasSpecialCharacterInString(this.userData.password_confirm)
      ) {
        this.showErrorModal(messageContent.hasSpecialCharacter);
      } else if (
        //check match password and repassword
        this.userData.password !== this.userData.password_confirm
      ) {
        this.showErrorModal(messageContent.newPasswordError);
      } else if (!this.passwordPatternCheck(this.userData.password)) {
        //check password format
        this.showErrorModal(messageContent.passwordFormatError);
      } else {
        const formDataTmp = {
          password: this.userData.current_password,
          newPassword: this.userData.password,
          _csrf: this.csrfToken,
        };
        this.postRequest('/idmgmt/changePassword', formDataTmp)
          .then(e => {
            if (e.session && e.status === 'success') {
              this.redirectToLogin();
            } else if (e.session && e.status === 'mailAuthLinkCreated') {
              this.handleShowMailAuthModal();
            } else if (e.status === 'loginFailed') {
              this.showErrorModal(e.msg);
            } else if (e.status === 'failed') {
              this.showErrorModal(messageContent.requireTry('パスワード更新'));
            } else {
              this.showErrorModal(messageContent.requireTry('パスワード更新'));
            }
          })
          .catch(er => {
            this.showErrorModal(messageContent.requireTry('パスワード更新'));
          });
      }
    },
    redirectToLogin() {
      window.location.href = '/login';
    },
    handleShowMailAuthModal() {
      this.mailAuthResultModalVisible = true;
      this.mailAuthResultModalTitle = messageContent.infoModalTitle;
      this.mailAuthresultModalContent = messageContent.mailAuthInChangePassword;
    },
    handleCloseMailAuthModal() {
      this.mailAuthResultModalVisible = false;
      this.redirectToLogin();
    },
  },
};
</script>
